export default {
  namespaced: true,

  state: {
    isOpen: true,
    height: 0
  },

  getters: {
    isOpen (state) {
      return state.isOpen
    },
    menuHeight (state) {
      return state.height
    }
  },

  mutations: {
    set (state, bool) {
      state.isOpen = bool
    },
    setHeight (state, height) {
      state.height = height
    }
  },

  actions: {
    open ({ commit }) {
      commit('set', true)
    },
    close ({ commit }) {
      commit('set', false)
    },
    updateHeight ({ commit }, height) {
      commit('setHeight', height)
    }
  }
}
